/* Dependencies */
import styled from 'styled-components';

const TopBarContainer = styled.div.attrs(() => ({
  className: 'TopBarContainer',
}))`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 10px;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.breakPoints.tablet} {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export default TopBarContainer;
